import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

export interface WalletStatus {
  status: string;
  walletType: string;
  balance: number;
  isBlocked: boolean;
  minRechargeAmount: number;
  showWarning: boolean;
  negBalanceSelectedServicesAllowed: boolean;
  blockingLimit: number;
  warningLimit: number;
}

interface CaptainStatusResponse {
  apiVersion: string;
  status: string;
  data: WalletStatus[];
}

@Injectable()
export class LimitStoreService {
    constructor(public httpClient: HttpClient) { }

    async getCaptainStatus(captainId: string): Promise<CaptainStatusResponse> {
        const url = `${environment.server}/api/${captainId}/status`;
        const result = await this.httpClient.get<CaptainStatusResponse>(url, {
            params: { walletTypes: ['rapidoWallet', 'dues'] }
        }).toPromise();
        return result;
    }
} 